import { AbstractControl } from "@angular/forms";

export function noPastDateValidator() {
  return (control: AbstractControl) => {
    if (!control.value) return null;

    const selected = new Date(control.value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return selected < today ? { pastDate: true } : null;
  };
}

export function endDateAfterStartDateValidator(
  startKey: string,
  endKey: string
) {
  return (group: AbstractControl) => {
    const start = group.get(startKey)?.value;
    const end = group.get(endKey)?.value;

    if (!start || !end) return null;

    return new Date(end) < new Date(start)
      ? { endBeforeStart: true }
      : null;
  };
}
